export function validateFullName(name: string) {
  return /\S{2,}(?=\s|\s\S\s).+\S{2,}/.test(name)
}
